import React, { useState, useEffect, useRef } from 'react';

import '../../styles/components/MedicalInput.scss';

const MedicalInput = ({ className, onChange, label, value, size = 'normal', suffix = '', icon = null, type = 'numeric', options = {}, min = 0, max, step = 1, initValue = false, ...props }) => {
  const [valueLabel, setValueLabel] = useState(value);
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);
  //const timeout = useRef(null);
  // -------
  // -------

  useEffect(() => {
    setValueLabel(value);
  }, [value])

  const updateNumericValue = (action) => {
    let numericValue;
    value = Number(value);
    if(!isNaN(value))
      numericValue = value;
    else{
      if(initValue)
        numericValue = initValue
      if(!numericValue)
        numericValue = 0;
    }
    numericValue = parseFloat(numericValue);
    numericValue = Math.round(numericValue * 100) / 100;
    step = parseFloat(step ?? 1);
    step = Math.round(step * 100) / 100;
    let modulo = numericValue % step;
    modulo = Math.round(modulo * 100) / 100;
    switch(action) {
      case 'decrease':
        if (modulo !== 0 && modulo !== Math.round(step * 100) / 100)
          numericValue -= modulo;
        else
        numericValue -= step;

        break;
      case 'increase':
        if (modulo !== 0 && modulo !== Math.round(step * 100) / 100) 
          numericValue -= modulo;
        numericValue += step;
        
        break;
      default:
        break;
    }
    numericValue = Math.round(numericValue * 100) / 100;
    numericValue = checkMinMax(numericValue)  
    onChange(numericValue)
    setValueLabel(numericValue);
  };

  const checkMinMax = (numericValue) =>{
    min = Number(min);
    if(!isNaN(min)){
      min = parseFloat(min);
      if (numericValue <= min){ 
        numericValue = min;
      }
    }    
    max = Number(max);
    if(!isNaN(max)){
      max = parseFloat(max);
      if (numericValue >= max) 
        numericValue = max;
    }  
    return numericValue;
  }
  // -------
  // -------
  const updateSelectValue = (action) => {
    const keys = Object.keys(options);
    if (keys.length > 0) {
      let index = keys.indexOf(value);
      if (index == -1) {
        index = 0;
      }
      switch(action) {
        case 'decrease':
          index -= 1;
          if (index < 0) {
            index = keys.length-1;
          }
          if (value != keys[index]) {
            onChange(keys[index]);
            setValueLabel(keys[index]);
          }
          break;
        case 'increase':
          index += 1;
          if (index >= keys.length) {
            index = 0;
          }
          if (value != keys[index]) {
            onChange(keys[index]);
            setValueLabel(keys[index]);
          }
          break;
      }
    }
  }

  // -------
  // -------
  const updateValue = (action) => {
    setFocused(true);
    switch(type) {
      case 'select':
        updateSelectValue(action);
        break;
      default:
        updateNumericValue(action);
        break;
    }
  };


  const handleKeyDown = (e) => {
    const allowedSpecialKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Enter'
    ];
    const allowedRegex = /^[0-9.,]$/;
    if (!allowedRegex.test(e.key) && !allowedSpecialKeys.includes(e.key)) {
      e.preventDefault();
      return;
    }
    if (e.key === ',') {
      e.preventDefault();

      const input = e.target;
      const { selectionStart, selectionEnd } = input; 

      let newValue =
        input.value.slice(0, selectionStart) +
        '.' +
        input.value.slice(selectionEnd);
        newValue = parseFloat(newValue).toFixed(1);
      setValueLabel(newValue);
      onChange(newValue);

      setTimeout(() => {
        input.setSelectionRange(selectionStart + 1, selectionStart + 1);
      }, 0);
    }
  };  

  const onChangeInput = (e) => {
    let value = e.target.value;
    if(isNaN(value))
      value = '';    
    setValueLabel(value);
    
    /*if (timeout.current)
     clearTimeout(timeout.current); 
    */
    /*if (value.slice(-1) === '.' || value.slice(-1) === ',') {
      return;
    }*/
    /*timeout.current = setTimeout(() => {
      if(isNaN(value)){
      value = '';
      setValueLabel(value);
      } 
      else if(value){
        const num = Math.round(parseFloat(value) * 100) / 100;
        value = (num % 1 === 0) ? num.toString() : num.toFixed(2);
        setValueLabel(num);
      }
      onChange(value);
    }, 800);*/
    
  }

  const handleBlur = (e) => {
    let value = Math.round(parseFloat(e.target.value * 100) ) / 100;
    value = parseFloat(value);
    value = checkMinMax(value);
    setValueLabel(value);
    onChange(value);
  }
  // -----
  return (
    <div className={`medical-input medical-input--${size} medical-input--${type} ${focused ? 'medical-input--focused' : '' } ${className ?? ''}`} {...props} onBlur={() => setFocused(false)}>
      <div className={`medical-input__inner`}>
        <label className={`medical-input__label`}>
          {icon != null ? (<span className={`medical-input__icon`}>{icon}</span>) : ''}
          <span className='medical-input__text'>{label}</span>
        </label>
        <div className={`medical-input__block`}>
          <button className='medical-input__arrow medical-input__arrow--minus' onClick={() => updateValue('decrease')}>
            {type == 'select' ? <span className='icon-chevron-down'></span> : <span className='icon-minus'></span>}
          </button>
          {type == 'select' ? (
            <span className={'medical-input__value'}>{options && options[valueLabel] ? options[valueLabel] : valueLabel }</span>
          ) : (
            <input 
              ref={inputRef} 
              type={'text'} 
              className={'medical-input__value medical-input__value--input'} 
              value={valueLabel} 
              onChange={onChangeInput}
              onKeyDown={handleKeyDown}
              placeholder={'-'}
              onBlur={handleBlur} 
              onFocus={() => setFocused(true)} />
          )}
          {suffix != '' ? (<span className={`medical-input__suffix`}>{suffix}</span>) : null}
          <button className='medical-input__arrow medical-input__arrow--plus' onClick={() => updateValue('increase')}>
            {type == 'select' ? <span className='icon-chevron-up'></span> : <span className='icon-plus'></span>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MedicalInput;